export default "__VITE_ASSET__DlARlj4j__"